import { getYear } from 'date-fns';
export default function convertYearRangeToArray(_ref) {
  let {
    min,
    max,
    selectedDates = []
  } = _ref;
  const allYearsAscending = (selectedDates || []).filter(x => x !== null).map(getYear).concat([min, max]).sort((a, b) => a - b);
  const minYear = allYearsAscending[0];
  const maxYear = allYearsAscending[allYearsAscending.length - 1];
  return Array.from({
    length: maxYear - minYear + 1
  }, (_, i) => ({
    key: i + minYear,
    label: i + minYear
  }));
}
//# sourceMappingURL=convertYearRangeToArray.js.map